// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }


  SITE.videoPlayer = function() {

    var players = Plyr.setup('.js-player', {
      'iconUrl' : '/wp-content/themes/sobrato/resources/images/plyr.svg',
      controls: [
        'play-large',
        'progress',
        'current-time', // The current time of playback
   'duration', // The full duration of the media
   'mute', // Toggle mute
   'volume', // Volume control
   'captions', // Toggle captions
   'settings', // Settings menu
   'pip', // Picture-in-picture (currently Safari only)
   'airplay', // Airplay (currently Safari only)
   'fullscreen', // Toggle fullscreen
      ]
    });


  }

})();


// Invocations

$(function () {
//SITE.videoPlayer();

});
